import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type AreYouSureDialogProps = {
  isDialogOpen: boolean;
  handleClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  title: string;
  content: ReactNode;
};
export default function AreYouSureDialog({
  isDialogOpen,
  handleClose,
  onSubmit,
  isSubmitting,
  title,
  content,
  ...rest
}: AreYouSureDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} open={isDialogOpen} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component={"span"} id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button aria-label="No" disabled={isSubmitting} onClick={handleClose}>
          {t("buttons.no")}
        </Button>
        {isSubmitting ? (
          <Button aria-label="Saving" variant="contained" disabled>
            <CircularProgress size={20} />
            {t("buttons.submitting")}
          </Button>
        ) : (
          <Button aria-label="Yes" onClick={onSubmit} variant="contained">
            {t("buttons.yes")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
